module.exports = __webpack_public_path__ + "img/LB.f0b169dc.png";